import React, { useState } from 'react';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import CustomMuiLink from 'common/components/custom-mui-link/CustomMuiLink';
import { Box, makeStyles } from '@material-ui/core';

const NavbarListItem: React.FC<IDopdownItemProps> = ({
  label,
  data,
}) => {
  const classes = useStyels();
  const [open, setOpen] = useState(false);

  return (
    <Box className={classes.listitem__root}>
      <ListItem onClick={() => setOpen(!open)}>
        <ListItemText
          primaryTypographyProps={{ variant: 'subtitle2' }}
        >
          {label}
        </ListItemText>
        {open ? <ExpandLess color="primary" /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          className={classes.listitem__inner}
        >
          {data.map(({ id, route, label, ...props }) => (
            <CustomMuiLink key={id} href={route} {...props}>
              <ListItem>
                <ListItemText>{label}</ListItemText>
              </ListItem>
            </CustomMuiLink>
          ))}
        </List>
      </Collapse>
    </Box>
  );
};

export default NavbarListItem;

const useStyels = makeStyles((theme) => ({
  listitem__root: {
    '& .MuiListItem-root': {
      cursor: 'pointer',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    '& .MuiListItem-root:hover': {
      width: '100%',
      backgroundColor: 'rgba(68, 146, 76, 0.04)',
    },
  },
  listitem__inner: {
    '& .MuiListItem-root': {
      paddingLeft: theme.spacing(8),
    },
  },
}));
